export default "__VITE_ASSET__$Ksv3zlh__"